import { ChessAI, createFakeEngine, createServerEngine } from '@chessmate/chess-ai';
import { CheckersAI, type MoveEngine } from '@chessmate/game-engine';
import type { GameId, RobotLevel } from '@chessmate/protocol';
import type { AppQuery } from '../lib/query.js';

export function createAppEngine(gameId: GameId, level: RobotLevel, query: AppQuery): MoveEngine {
  if (gameId === 'checkers') return new CheckersAI();
  const raw =
    query.engine === 'fake'
      ? createFakeEngine({ script: query.moves })
      : createServerEngine({ baseUrl: import.meta.env.VITE_API_URL ?? '' });
  const ai = new ChessAI(raw);
  void ai.init().catch(() => {
    // Api-offline: init failure surfaces as a move-time error, not a crash.
  });
  return ai;
}
